import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { palette } from '@client/theme/colors';
import { theme } from '../constants';
import type { ThemeOptions } from '@mui/material';

const Rating: ThemeOptions['components'] = {
  MuiRating: {
    defaultProps: {
      icon: <FavoriteIcon fontSize="inherit" />,
      emptyIcon: <FavoriteBorderIcon fontSize="inherit" />,
    },
    styleOverrides: {
      root: {
        display: 'flex',
      },
      sizeSmall: {
        fontSize: '16px',
      },
      sizeMedium: {
        fontSize: '30px',
      },
      label: {
        paddingRight: theme.spacing(1 / 2),
      },
      icon: {
        color: palette.error.main,
        transform: 'scale(1.2)',
      },
      iconFilled: {
        color: palette.error.main,
      },
      readOnly: {
        '& > span': {
          paddingRight: theme.spacing(1 / 2),
        },
      },
    },
  },
};

export default Rating;
